import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { OutageBannerComponent } from './outage-banner.component';

@NgModule({
  declarations: [OutageBannerComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [],
  exports: [OutageBannerComponent],
})
export class OutageBannerModule {}
